import { render, staticRenderFns } from "./ResponseViewer.vue?vue&type=template&id=72bd5b07&scoped=true"
import script from "./ResponseViewer.vue?vue&type=script&lang=ts"
export * from "./ResponseViewer.vue?vue&type=script&lang=ts"
import style0 from "./ResponseViewer.vue?vue&type=style&index=0&id=72bd5b07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd5b07",
  null
  
)

export default component.exports